import { RootState } from '../rootReducer'
import { Location } from '../../lib/interfaces/Location.interface'

const get = require('lodash/get')

export const getPrincipalLocation = (state: RootState): Location|undefined => get(state, 'auth.user.employee.location')



// WEBPACK FOOTER //
// ./src/store/auth/selectors.ts